import configs, { EProjectPlatform } from '../configs';

export const checkIsNative = () => {
  return configs.platform === EProjectPlatform.NATIVE;
};
